import { useEffect, useState } from "react";

export type OrgSwitcherExperience = "classic" | "new";

const KEY = "orgSwitcherExperience";
const EVENT = "orgSwitcherExperienceChange";

const read = (): OrgSwitcherExperience =>
  typeof window !== "undefined" && window.localStorage.getItem(KEY) === "new"
    ? "new"
    : "classic";

export const useOrgSwitcherExperience = (): [
  OrgSwitcherExperience,
  (next: OrgSwitcherExperience) => void,
] => {
  const [experience, setExperience] = useState<OrgSwitcherExperience>(read);

  useEffect(() => {
    const sync = () => setExperience(read());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const update = (next: OrgSwitcherExperience) => {
    window.localStorage.setItem(KEY, next);
    setExperience(next);
    window.dispatchEvent(new Event(EVENT));
  };

  return [experience, update];
};
